import { useCalcDocContentPaddingTop } from '@/hooks/useCalcDocContentPaddingTop';
import { useCalcNavbarHeight } from '@/hooks/useCalcNavbarHeight';
import { useCalcNotificationHeight } from '@/hooks/useCalcNotificationHeight';
import CodeBlockVirtual from '@/ui-kit/components/CodeBlock';
import clsx from 'clsx';
import styles from './DataSchemaExample.module.css';

type DataSchemaExampleProps = {
  code: string;
  className?: string;
};

export function DataSchemaExample(props: DataSchemaExampleProps) {
  const navbarHeight = useCalcNavbarHeight();
  const notificationHeight = useCalcNotificationHeight();
  const docPaddingTop = useCalcDocContentPaddingTop();

  return (
    <div className="pointer-events-none @[850px]/http-api-content:flex @[850px]/http-api-content:justify-end">
      <div
        className={clsx(
          'pointer-events-auto flex !h-auto flex-col gap-5 p-0 @[850px]/http-api-content:fixed @[850px]/http-api-content:bottom-0 @[850px]/http-api-content:mr-[-440px] @[850px]/http-api-content:w-[440px] @[850px]/http-api-content:pb-5 @[850px]/http-api-content:pl-10',
          props.className,
        )}
        style={{
          top: navbarHeight + notificationHeight + docPaddingTop + 20,
        }}
      >
        <CodeBlockVirtual
          className={clsx(styles['code-viewer'], 'max-h-full bg-code-viewer')}
          code={props.code}
          language="json"
          highlightTheme="github-dark"
          onlyCode={false}
        />
      </div>
    </div>
  );
}
